<script lang="ts" setup>
import { Video } from '~/types';
import VLazyImage from 'v-lazy-image';
import { Icon } from '@iconify/vue';
import { useVideoPopupStore } from '~/stores/useVideoPopupStore';

export interface Item {
  title: string;
  description?: string;
  video: Video;
}

interface Props {
  item: Item;
}

defineProps<Props>();

const videoPopupStore = useVideoPopupStore();
</script>

<template>
  <div v-if="item.video" class="testimonials-item">
    <div v-if="item.video?.poster_url" class="testimonials-item__image-wrapper">
      <VLazyImage :src="item.video.poster_url" :alt="item.title" class="testimonials-item__image" />
    </div>
    <div class="testimonials-item__body">
      <button class="testimonials-item__button" @click.prevent="videoPopupStore.setVideo(item.video)">
        <span class="sr-only">Play Video</span>
        <Icon icon="zondicons:play" class="testimonials-item__icon" />
      </button>
      <div class="testimonials-item__text">
        <strong v-if="item.title" class="testimonials-item__title">{{ item.title }}</strong>
        <p v-if="item.description" class="testimonials-item__description">{{ item.description }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.testimonials-item {
  @apply w-full aspect-[4/5] relative rounded-10 bg-dark overflow-hidden flex items-end px-5 py-10;
  @apply 2xl:px-8;

  &__image-wrapper {
    @apply absolute w-full h-full inset-0;
    @apply before:h-1/2 before:w-full before:absolute before:bottom-0 before:left-0 before:bg-gradient-to-t before:from-black/80 before:z-[1];
  }

  &__image {
    @apply absolute w-full h-full inset-0 object-cover object-center;
  }

  &__body {
    @apply relative z-[2] flex gap-5 items-center;
  }

  &__text {
    @apply flex flex-col gap-2;
  }

  &__title {
    @apply leading-[1.1] text-white text-[20px] font-medium;
    @apply xl:text-[24px];
  }

  &__description {
    @apply text-[14px] text-white leading-[1.3];
    @apply xl:text-[16px];
  }

  &__button {
    @apply min-w-[40px] min-h-[40px] rounded-md border-[2px] border-white flex items-center justify-center text-white duration-300 hover:bg-white hover:text-accent;
    @apply xl:min-w-[60px] xl:min-h-[60px];
  }

  &__icon {
    @apply w-2/5 h-2/5;
  }
}
</style>
